import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import "./FormProponente.css";
import { Container, Row, Col } from "react-bootstrap";
import NewFormular from "./NewFormular/NewFormular";
import ToggleButtonProponent from "../ToggleButtonProponent/ToggleButtonProponent";

const FormProponente = () => {
  return (
    <section className="mt-4">
      <Container className="custom-margin-left mt-3 p-0 mb-2" fluid>
        <Row className="d-flex align-items-start">
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
          >
            <GenerateQuestion
              header="Deseja adicionar outros proponentes?"
              subheader="Adiciona até 3 proponentes, caso não tenha preenchido o campo de cônjuge."
            />
          </Col>
          <Col xs={1} sm={1} md={1} lg={1}></Col>
          <Col className=" me-xl-5 mx-2 ">
            <ToggleButtonProponent
              id="1"
              textOn="Adicionar proponentes"
              textOff="Adicionar proponentes"
            >
              <NewFormular name1="Proponente 3" name2="Proponente 4" />
            </ToggleButtonProponent>
            <Col xs={12} md={6} lg={4} className="mb-3"></Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FormProponente;
